declare global {
  interface Window {
    EcalWidget?: (action: "boot", opts: { apiKey: string }) => void;
    syncDisplayTO?: NodeJS.Timeout;
  }
}

/*
 * Place this script on NextJS / ReactJS component that will render the sync button(s)
 * call this function before the button is rendered.
 */
export function renderSyncDisplay(apikey: string) {
  clearTimeout(window.syncDisplayTO);
  function bootSyncDisplay() {
    const ecalBtns = document.getElementsByClassName("ecal-sync-widget-button");
    if (window.EcalWidget && ecalBtns.length > 0 && apikey) {
      window.EcalWidget("boot", { apiKey: apikey });
      return;
    }
    window.syncDisplayTO = setTimeout(bootSyncDisplay, 300);
  }
  window.syncDisplayTO = setTimeout(bootSyncDisplay, 300);
}
